import React from "react";
import View from "common/View";
import SoftwareList from "./SoftwareList";
import help from "help/viewSoftware.md";

const options = [
  {
    signal: "install-software",
    label: "Install",
  },
];

export const SoftwareAdmin = ({returnView}) => {
  return (
  <View
    title="Software Packages"
    className="container-lg"
    options={options}
    mdHelp={help}
    returnView={returnView}
  >
    <SoftwareList />
  </View>
)};

export default SoftwareAdmin;
